import { HttpClientModule } from '@angular/common/http';
import { LOCALE_ID, DoBootstrap, NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './modules/material/material.module';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Router } from '@angular/router';
import { RecaptchaModule } from 'angular-google-recaptcha';
import { FileUploadModule } from 'ng2-file-upload';
import { AppComponent } from './app.component';
import { FileUploaderComponent } from './componentes/file-uploader/file-uploader.component';
import { LoadingPageComponent } from './componentes/loading-page/loading-page.component';
import { HeaderComponent } from './layouts/header/header.component';
import { HttpInterceptorProviders } from './interceptor';
import { NumeroProcessoPipe } from './pipe/numero-processo.pipe';
import { NumeroCNSPipe } from './pipe/numero-cns.pipe';
import { routes } from './rotas/app-routing';
import { AuthGuardService } from './service/autenticacao/auth-guard.service';
import { AuthService } from './service/autenticacao/auth.service';
import { CadastroComponent } from './view/usuario/cadastro/cadastro.component';
import { HomeComponent } from './view/home/home.component';
import { InformacaoComponent } from './view/manifestos/informacao/informacao.component';
import { SolicitacaoComponent } from './view/manifestos/solicitacao/solicitacao.component';
import { SugestaoComponent } from './view/manifestos/sugestao/sugestao.component';
import { SucessoCadastroUsuarioComponent } from './view/sucesso-cadastro-usuario/sucesso-cadastro-usuario.component';
import { SucessoComponent } from './view/sucesso/sucesso.component';
import { DenunciaComponent, JudicialAdministrativoComponent } from './view/manifestos/denuncia';
import { CartorioExtrajudicialCriticaComponent, CriticaComponent, NaturezaAdministrativaCriticaComponent} from './view/manifestos/critica';
import { RedefinirSenhaComponent } from './view/usuario/redefinir-senha/redefinir-senha.component';
import { RedefinirSenhaEmailComponent } from './view/usuario/redefinir-senha-email/redefinir-senha-email.component';
import { LoginComponent } from './view/usuario/login/login.component';
import { ElogioComponent, ServicosAcoesPrestadosComponent, CartorioExtrajudicialElogioComponent } from './view/manifestos/elogio';
import { ServicosAcoesAdmSolicitacaoComponent } from './view/manifestos/solicitacao/servicos-acoes-adm-solicitacao/servicos-acoes-adm-solicitacao.component';
import { ServicosAcoesAdmSugestaoComponent } from './view/manifestos/sugestao/servicos-acoes-adm-sugestao/servicos-acoes-adm-sugestao.component';
import { CartoriosExtrajudiciaisCapitalInformacaoComponent } from './view/manifestos/informacao/cartorios-extrajudiciais-capital-informacao/cartorios-extrajudiciais-capital-informacao.component';
import { CartoriosExtrajudiciaisInteriorInformacaoComponent } from './view/manifestos/informacao/cartorios-extrajudiciais-interior-informacao/cartorios-extrajudiciais-interior-informacao.component';
import { ProcessoInformacaoComponent } from './view/manifestos/informacao/processo-informacao/processo-informacao.component';
import { ServicosAcoesAdmInformacaoComponent } from './view/manifestos/informacao/servicos-acoes-adm-informacao/servicos-acoes-adm-informacao.component';
import { ConsultaComponent } from './view/manifestos/consulta/consulta.component';
import { CartoriosExtrajudicialConsultaComponent } from './view/manifestos/consulta/cartorios-extrajudicial-consulta/cartorios-extrajudicial-consulta.component';
import { ProcessoSolicitacaoComponent } from './view/manifestos/solicitacao/processo-solicitacao/processo-solicitacao.component';
import { EsqueciSenhaEmailComponent } from './view/usuario/esqueci-senha-email/esqueci-senha-email.component';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import localeExtraPt from '@angular/common/locales/extra/pt';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { OAuthModule } from 'angular-oauth2-oidc';
import { AppAuthService } from './service/auth/auth.service';
import { KeycloakAdapterService } from './service/auth/keycloak-adapter.service';
import { environment } from 'src/app/environment';
import { KEYCLOAK_BEARER_EXCLUDED_URLS } from 'src/app/tools/URL';
import { PesquisarUsuarioComponent } from './view/usuario/pesquisar-usuario/pesquisar-usuario.component';
import { MatIconModule } from '@angular/material/icon';
import {
  ReclamacaoComponent,
  CartorioExtrajudicialComponent,
  ProcessoComponent,
  NaturezaDisciplinarComponent,
  NaturezaAdministrativaComponent,
  SistemasInformatizadosComponent
} from 'src/app/view/manifestos/reclamacao';
import { HomeOperadorComponent } from 'src/app/view/usuario-interno/home/home-operador.component';
import { CadastroManifestoOperadorComponent } from 'src/app/view/usuario-interno/operador/manifesto/cadastro/cadastro-manifesto-operador.component';
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { ClassificacaoComponent } from './componentes/classificacao/classificacao.component';
import { PesquisaManifestoOperadorComponent } from './view/usuario-interno/operador/manifesto/pesquisa/pesquisa-manifesto-operador.component';
import { RespostaManifestoOperadorComponent } from './view/usuario-interno/operador/manifesto/resposta/resposta-manifesto-operador.component';
import { AppConfig } from './app.config';
import { ManifestoPorOperadorComponent } from './view/usuario-interno/gestor/relatorio/manifesto-por-operador/manifesto-por-operador.component';
import { ManifestoPorTemaComponent } from './view/usuario-interno/gestor/relatorio/manifesto-por-tema/manifesto-por-tema.component';
import { SemPermissaoComponent } from './view/usuario-interno/sem-permissao/sem-permissao.component';
import { LgpdComponent } from './view/manifestos/lgpd/lgpd.component';
import { SolicitacoesInformacoesLgpdComponent } from './view/manifestos/lgpd/solicitacoes-informacoes-lgpd/solicitacoes-informacoes-lgpd.component';
import { ConfirmWindowComponent } from './componentes/confirm-window/confirm-window.component';
//import { ConfirmationDialogComponent } from './componentes/confirmation-dialog/confirmation-dialog.component';
import { ModalModule, BsModalRef  } from 'ngx-bootstrap/modal';
import { RepresentanteLegalLgpdComponent } from './view/manifestos/lgpd/representante-legal/representante-legal-lgpd.component';
import { TitularDadosLgpdComponent } from './view/manifestos/lgpd/titular-dados/titular-dados-lgpd.component';
import { CpfPipe } from './pipe/mascara-cpf.pipe';
import { ReeducandoComponent } from './view/manifestos/solicitacao/reeducando/reeducando.component';
import { PesquisaManifestoUsuarioComponent } from './view/usuario/pesquisa/pesquisa-manifesto-usuario.component';
import { AtivarContaComponent } from './view/usuario/ativar-conta/ativar-conta.component';
import { DenunciaAnonimaComponent } from './view/manifestos/denuncia-anonima/denuncia-anonima.component';
import { DenunciaAnonimaSucessoComponent } from './view/manifestos/denuncia-anonima/denuncia-anonima-sucesso/denuncia-anonima-sucesso.component';
import { DenunciaAnonimaAvisoComponent } from './view/manifestos/denuncia-anonima/denuncia-anonima-aviso/denuncia-anonima-aviso.component';
import { DenunciaAnonimaRecomendacoesComponent } from './view/manifestos/denuncia-anonima/denuncia-anonima-recomendacoes/denuncia-anonima-recomendacoes.component';
import { HomeGovbrComponent } from './view/home/home-govbr/home-govbr.component';
import { NgxMaskModule } from 'ngx-mask';
import { CpeComponent } from './view/manifestos/cpe/cpe.component';
import { RequerimentoGeralComponent } from './view/manifestos/cpe/requerimento-geral/requerimento-geral.component';
import { PropriaParteRequerimentoGeralComponent } from './view/manifestos/cpe/requerimento-geral/propria-parte-requerimento-geral/propria-parte-requerimento-geral.component';
import { TermosComponent } from './view/manifestos/cpe/shared/termos/termos.component';
import {
  ManifestoPorUsuarioComponent
} from "./view/usuario-interno/gestor/relatorio/manifesto-por-usuario/manifesto-por-usuario.component";
import {AdvogadoRegistroComponent} from "./view/manifestos/cpe/shared/advogado-registro/advogado-registro.component";
import {CpeProcessoComponent} from "./view/manifestos/cpe/shared/cpe-processo/cpe-processo.component";
import { ParteInformacaoRequerenteComponent } from './view/manifestos/cpe/shared/parte-informacao-requerente/parte-informacao-requerente.component';
import { JustificativaComponent } from './view/manifestos/cpe/shared/justificativa/justificativa.component';
import { TelefoneComponent } from './view/manifestos/cpe/shared/telefone/telefone.component';
import { DocumentoComponent } from './view/manifestos/cpe/shared/documento/documento.component';
import { PeloAdvogadoRequerimentoGeralComponent } from './view/manifestos/cpe/requerimento-geral/pelo-advogado-requerimento-geral/pelo-advogado-requerimento-geral.component';
import { DesarquivamentoAutosComponent } from './view/manifestos/cpe/desarquivamento-autos/desarquivamento-autos.component';
import { ModalComponent } from './view/manifestos/cpe/shared/modal/modal.component';
import { CpeOperadorComponent } from './componentes/cpe-operador/cpe-operador.component';
import { RestituicaoFormComponent } from './view/manifestos/consulta/cartorios-extrajudicial-consulta/partials/restituicao-form/restituicao-form.component';
import { MonitoramentoConciliacaoFormComponent } from './view/manifestos/consulta/cartorios-extrajudicial-consulta/partials/monitoramento-conciliacao-form/monitoramento-conciliacao-form.component';
import { DadosConciliadorMediadorComponent } from './view/manifestos/consulta/cartorios-extrajudicial-consulta/dados-conciliador-mediador/dados-conciliador-mediador.component';
import { FaleComRhComponent } from './view/manifestos/fale-com-rh/fale-com-rh.component';
import { LaiComponent } from './view/manifestos/lai/lai.component';
import { LaiOperadorComponent } from './view/manifestos/lai/lai-operador/lai-operador.component';
import { CarbonInputComponent } from './componentes/carbon/carbon-input/carbon-input.component';
import { AlertBoxComponent } from './componentes/carbon/alert-box/alert-box.component';
import { CarbonTitleBoxComponent } from './componentes/carbon/carbon-title-box/carbon-title-box.component';
import { CarbonRadionGroupComponent } from './componentes/carbon/carbon-radion-group/carbon-radion-group.component';
import { CarbonCheckboxGroupComponent } from './componentes/carbon/carbon-checkbox-group/carbon-checkbox-group.component';
import { DadosCadastraisComponent } from './view/manifestos/fale-com-rh/partials/dados-cadastrais/dados-cadastrais.component';
import { CarbonTextareaComponent } from './componentes/carbon/carbon-textarea/carbon-textarea.component';
import { CpfMaskDirective} from "./directive/CpfMaskDirective";
import { AgenciaBancariaMaskDirective} from "./directive/AgenciaBancariaMaskDirective";
import { ContaBancariaMaskDirective} from "./directive/ContaBancariaMaskDirective";
import { DigitoVerificadorMaskDirective} from "./directive/DigitoVerificadorMaskDirective";
import { TelefoneFixoMaskDirective} from "./directive/TelefoneFixoMaskDirective";
import { TelefoneCelularMaskDirective} from "./directive/TelefoneCelularMaskDirective";
import { CarbonSelectOptionComponent } from './componentes/carbon/carbon-select-option/carbon-select-option.component';
import { CepMaskDirective} from "./directive/CepMaskDirective";
import { NumeroProcessoMaskDirective} from "./directive/NumeroProcessoMaskDirective";
import { ContaBancariaComponent } from './view/manifestos/fale-com-rh/partials/conta-bancaria/conta-bancaria.component';
import { ObitoComponent } from './view/manifestos/fale-com-rh/partials/obito/obito.component';
import { AssedioComponent } from './view/manifestos/denuncia/partials/assedio/assedio.component';
import { ViolenciaGeneroComponent } from './view/manifestos/reclamacao/violencia-genero/violencia-genero.component';
import { FaleComRhOperadorComponent } from './view/manifestos/fale-com-rh/fale-com-rh-operador/fale-com-rh-operador.component';
import { CarbonButtonComponent } from './componentes/carbon/carbon-button/carbon-button.component';
import { SolicitacaoDocumentoComponent } from './view/manifestos/fale-com-rh/partials/solicitacao-documento/solicitacao-documento.component';
import { InfanciaJuventudeComponent } from './view/manifestos/denuncia/partials/infancia-juventude/infancia-juventude.component';
import { InputProcessoComponent } from './componentes/input-processo/input-processo.component';
import { PrioridadePessoaIdosaAvisoComponent } from './componentes/prioridade-pessoa-idosa-aviso/prioridade-pessoa-idosa-aviso.component';


registerLocaleData(localePt, 'pt', localeExtraPt);
// Keep KeycloakAngularModule but provide an adapter service to replace direct KeycloakService usage.

export function initializeApp(environmentConfig: environment) {
  return (): Promise<AppConfig> => environmentConfig.load();
}

export function initializeAuthFactory(appAuthService: AppAuthService, env: environment) {
  return (): Promise<void> => {
    // Ensure the runtime environment config is loaded before initializing the OIDC client.
    // Call env.load() to guarantee the config is available (it's safe to call multiple times).
    return (env.load() as Promise<any>)
      .then(() => {
        const cfg: any = (<any>environment).settings && (<any>environment).settings.keycloakConfig;
        if (!cfg) {
          // nothing to init
          return Promise.resolve();
        }
        return appAuthService.init(cfg).catch(() => undefined);
      })
      .catch(() => Promise.resolve());
  };
}

@NgModule({
    declarations: [
        AppComponent,
        LoadingPageComponent,
        HeaderComponent,
        HomeComponent,
        NumeroProcessoPipe,
        NumeroCNSPipe,
        CpfPipe,
        ReclamacaoComponent,
        ViolenciaGeneroComponent,
        CartorioExtrajudicialComponent,
        NaturezaAdministrativaComponent,
        ProcessoComponent,
        NaturezaDisciplinarComponent,
        SistemasInformatizadosComponent,
        DenunciaComponent,
        JudicialAdministrativoComponent,
        LoginComponent,
        CadastroComponent,
        SucessoComponent,
        FileUploaderComponent,
        SucessoCadastroUsuarioComponent,
        CriticaComponent,
        CartorioExtrajudicialCriticaComponent,
        NaturezaAdministrativaCriticaComponent,
        ElogioComponent,
        SolicitacaoComponent,
        SugestaoComponent,
        InformacaoComponent,
        RedefinirSenhaComponent,
        RedefinirSenhaEmailComponent,
        EsqueciSenhaEmailComponent,
        ServicosAcoesPrestadosComponent,
        CartorioExtrajudicialElogioComponent,
        ServicosAcoesAdmSolicitacaoComponent,
        ServicosAcoesAdmSugestaoComponent,
        CartoriosExtrajudiciaisCapitalInformacaoComponent,
        CartoriosExtrajudiciaisInteriorInformacaoComponent,
        ProcessoInformacaoComponent,
        ServicosAcoesAdmInformacaoComponent,
        ConsultaComponent,
        CartoriosExtrajudicialConsultaComponent,
        ProcessoSolicitacaoComponent,
        PesquisarUsuarioComponent,
        HomeOperadorComponent,
        CadastroManifestoOperadorComponent,
        ClassificacaoComponent,
        PesquisaManifestoOperadorComponent,
        RespostaManifestoOperadorComponent,
        ManifestoPorUsuarioComponent,
        ManifestoPorOperadorComponent,
        ManifestoPorTemaComponent,
        SemPermissaoComponent,
        LgpdComponent,
        TitularDadosLgpdComponent,
        RepresentanteLegalLgpdComponent,
        SolicitacoesInformacoesLgpdComponent,
        ConfirmWindowComponent,
        ReeducandoComponent,
        PesquisaManifestoUsuarioComponent,
        AtivarContaComponent,
        DenunciaAnonimaComponent,
        DenunciaAnonimaAvisoComponent,
        DenunciaAnonimaRecomendacoesComponent,
        DenunciaAnonimaSucessoComponent,
        HomeGovbrComponent,
        CpeComponent,
        RequerimentoGeralComponent,
        CpeProcessoComponent,
        PropriaParteRequerimentoGeralComponent,
        AdvogadoRegistroComponent,
        TermosComponent,
        ParteInformacaoRequerenteComponent,
        JustificativaComponent,
        TelefoneComponent,
        DocumentoComponent,
        PeloAdvogadoRequerimentoGeralComponent,
        DesarquivamentoAutosComponent,
        ModalComponent,
        CpeOperadorComponent,
        DadosConciliadorMediadorComponent,
        RestituicaoFormComponent,
        MonitoramentoConciliacaoFormComponent,
        FaleComRhComponent,
        LaiComponent,
        LaiOperadorComponent,
        CarbonInputComponent,
        AlertBoxComponent,
        CarbonTitleBoxComponent,
        CarbonRadionGroupComponent,
        CarbonCheckboxGroupComponent,
        DadosCadastraisComponent,
        CarbonTextareaComponent,
        CpfMaskDirective,
        AgenciaBancariaMaskDirective,
        ContaBancariaMaskDirective,
        DigitoVerificadorMaskDirective,
        TelefoneFixoMaskDirective,
        TelefoneCelularMaskDirective,
        CarbonSelectOptionComponent,
        CepMaskDirective,
        NumeroProcessoMaskDirective,
        ContaBancariaComponent,
        ObitoComponent,
        SolicitacaoDocumentoComponent,
        FaleComRhOperadorComponent,
        CarbonButtonComponent,
        InfanciaJuventudeComponent,
        InputProcessoComponent,
        AssedioComponent,
        InputProcessoComponent,
        PrioridadePessoaIdosaAvisoComponent
    ],
  imports: [
    ModalModule.forRoot(),
    ReactiveFormsModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    FileUploadModule,
    MaterialModule,
  KeycloakAngularModule,
  OAuthModule.forRoot(),
    RouterModule.forRoot(routes),
    // RecaptchaModule.forRoot({ siteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI' }) - key para teste
    RecaptchaModule.forRoot({siteKey: '6LcMHtYUAAAAAG2ZsWYxBTxebGe_N57jOeyqQWwn'}),
    KeyboardShortcutsModule.forRoot(),
    NgxMaskModule.forRoot(),
    MatIconModule,

  ],
  providers: [
    environment,
    { provide: APP_INITIALIZER, useFactory: initializeApp, deps: [environment], multi: true },
  { provide: APP_INITIALIZER, useFactory: initializeAuthFactory, deps: [AppAuthService, environment], multi: true },
    AuthGuardService,
    AuthService,
    HttpInterceptorProviders,
    { provide: LOCALE_ID, useValue: 'pt' },
    KeycloakAdapterService,
    {
      provide: KeycloakService,
      useExisting: KeycloakAdapterService
    },
    AppAuthService
  ],

  entryComponents: [
    AppComponent,
    ConfirmWindowComponent
  ]
})
export class AppModule implements DoBootstrap  {

  async ngDoBootstrap(app: any) {

    const { keycloakConfig } = environment.settings;

    // AppAuthService is initialized via APP_INITIALIZER (initializeAuthFactory).
    // We don't call Keycloak adapter init here anymore to avoid double-init and redirect loops.
    app.bootstrap(AppComponent);

  }

}
